import React from 'react';
import {NavLink, Route, Routes, useParams, useLocation} from 'react-router-dom';
import { getOne } from './../../../common/v4/BackendProvider'
import Feature from '../../Feature';
const cx = require('classnames');
import { useState, useEffect } from 'react';

const NavBar = (props) => {

    const [data, setData] = useState({});
    const account_id = props.account_id;
    const urlattrs = { account_id };
    useEffect(() => {
        getOne('/admin/clients/clients/', props.account_id).then(response => {
            setData(response.data.data);
        });
    }, [props.account_id]);

    const url = '/admin/clients/accounts/{$account_id}';
    const routes = [
        {url: 'edit', name: 'Main'},
        
        {url: 'webaccounts', name: 'Users'},
        {url: 'summary', name: 'Summary'},
        {url: 'billing', name: 'Billing'},
        {url: 'numbers', name: 'Numbers'},
        
        
        // {url: 'invoices', name: 'Invoices'},
        // {url: 'voicecdr', name: 'Voice CDR', feature: 'voice-wholesale'},
        {url: 'aliases', name: 'Voice Accounts', feature: 'voice-retail'},
        {url: 'smppaccounts', name: 'SMPP Accounts', feature: 'sms-wholesale'},
        {url: 'apitokens', name: 'API Tokens'},
        // {url: 'mmsaccounts', name: 'MMS Accounts', feature: 'sms-wholesale'},
        // {url: 'smslog', name: 'SMS Log', feature: 'sms-wholesale'},
        // {url: 'api', name: 'API Access', feature: 'sms-wholesale'},
        // {url: 'client_webhooks', name: 'Client Webhooks', feature: 'sms-wholesale'}
    ];

    
    return (
         <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>Client {data?.ATRCLIENTIDNUMBER} - { data?.ATRACCTNAME }</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <ul className="nav nav-tabs">
                        {
                            routes.map(function (row, i) {
                                var location = '/clients/clients/' + account_id + '/' + row.url;
                                var link = <NavLink end={true} to={ location }>{row.name}</NavLink>
                                return (
                                    row.feature ? (
                                        <Feature key={i} name={row.feature}>
                                            <li key={i} role="presentation" className={cx(location == props.pathname ? "active" : "")}>
                                                { link }
                                            </li>
                                        </Feature>
                                    ) : (
                                        <li key={i} role="presentation" className={cx(location == props.pathname ? "active" : "")}>
                                            { link }
                                        </li>
                                    )
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

const Accounts = (props) => {
    const { account_id } = useParams();
    const location = useLocation();
    const urlattrs = { account_id };
    return (
        <div>
            <NavBar
                urlattrs={urlattrs}
                children={props.children}
                account_id={account_id}
                pathname={location.pathname}
            />
            <Routes>
                {props.routes.map((route, i) => (
                    <Route 
                        key={i} 
                        path={route.path} 
                        element={<route.component routes={route.routes} childProps={props.childProps}/>} 
                    />
                ))}
            </Routes>
        </div>
    );
};

export default Accounts;
